// extracted by mini-css-extract-plugin
module.exports = {"syhbwn4":"syhbwn4"};